import React from 'react';

export default function ImagesTable() {
	return (
		<div className="table-view table-responsive">
			<table id="upload-images-table" className="table">
				<thead>
					<tr>
						<th></th>
						<th>File Name</th>
						<th>Date Uploaded</th>
						<th>Uploaded By</th>
						<th>Company Logo</th>
						<th>Actions</th>
					</tr>
				</thead>
				<tbody></tbody>
			</table>
		</div>
	);
}
